import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Users, UserCheck } from 'lucide-react';
import { toast } from 'sonner';
import CommunityUnderConstruction from '@/components/community/CommunityUnderConstruction';

const CommunityPage = () => {
  const { user, isAdmin, isLoading, checkIsApprovedMember } = useAuth();
  const navigate = useNavigate();
  
  useEffect(() => {
    if (user) {
      checkIsApprovedMember();
    }
  }, [user, checkIsApprovedMember]);
  
  useEffect(() => {
    if (!isLoading && !user) {
      navigate('/join');
      toast.error('Please log in to access the community.');
    }
  }, [isLoading, user, navigate]);
  
  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-omoduduwa-terracotta border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-lg text-white">Loading community...</p>
        </div>
      </div>
    );
  }
  
  if (!user) {
    return null;
  }

  // The community page is under construction, so we'll show a message for everyone.
  return <CommunityUnderConstruction />;

  /*
  // NOTE: Previous logic is preserved below for when construction is complete.
  
  if (!isApprovedMember) {
    return <PendingApprovalMessage />;
  }
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
      <div className="bg-omoduduwa-indigo text-white py-12">
        <div className="container-custom">
          <h1 className="text-3xl md:text-4xl font-bold mb-2 text-white">
            YPL Community
          </h1>
          <p className="text-lg text-gray-200 max-w-2xl">
            Connect with fellow members and build a stronger democracy together
          </p>
          {isAdmin && (
            <div className="mt-4">
              <Button 
                onClick={() => navigate('/admin')}
                className="bg-omoduduwa-terracotta hover:bg-omoduduwa-terracotta/90"
              >
                Admin Dashboard
              </Button>
            </div>
          )}
        </div>
      </div>
      
      <div className="container-custom py-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <Users size={20} />
                  Community Members
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-gray-600">Community features are being rebuilt. Check back soon!</p>
              </CardContent>
            </Card>
          </div>
          
          <div className="space-y-6">
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <UserCheck size={20} />
                  Welcome to YPL Community
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-gray-600 mb-4">
                  You are now part of the Yoruba People's League community. 
                  Connect with other members and stay engaged with democratic activities.
                </p>
                <div className="space-y-2 text-sm text-gray-500">
                  <p>• View community members</p>
                  <p>• Stay updated with news and resources</p>
                  <p>• Participate in democratic activities</p>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
  */
};

export default CommunityPage;
